import { createSelector } from 'reselect';
var selectNewsGroupsState = function (_a) {
    var newsGroups = _a.newsGroups;
    return newsGroups;
};
/**
 * Selects the entities of the state
 */
var newsGroupsStateEntitiesSelector = createSelector(selectNewsGroupsState, function (_a) {
    var _b = _a.ids, ids = _b === void 0 ? [] : _b, _c = _a.entities, entities = _c === void 0 ? {} : _c;
    return ids.map(function (id) { return entities[id]; });
});
export default newsGroupsStateEntitiesSelector;
